import * as joint from '@clientio/rappid'

import GraphState from './../rappid/graph-state'

import { EventBus } from '@/event-bus'
import { Link } from '@/models/link.model'
import { Artifact } from '@/models/artifact.model'
import { ArtifactType } from '@/models/artifact-type.model'
import { useTraceDataStore } from '@/stores/traceDataStore'

function getArtifactWithID(id: string, artifacts: Artifact[]): Artifact {
  for (let index = 0; index < artifacts.length; index++) {
    const currentArtifact = artifacts[index]
    if (currentArtifact.id === Number(id)) {
      return currentArtifact
    }
  }
  return artifacts[0]
}

function getArtifactFromElementView(elementView: joint.dia.ElementView): Artifact | undefined {
  const cell = (elementView as any).model
  if (cell) {
    const artifact = cell.prop(GraphState.PROP_ARTIFACT)
    if (artifact !== undefined) {
      return artifact
    }
  }
  return undefined
}

function getArtifactFromElementModel(elementModell: any): Artifact | undefined {
  if (elementModell) {
    const artifact = elementModell.prop(GraphState.PROP_ARTIFACT)
    if (artifact !== undefined) {
      return artifact
    }
  }
  return undefined
}

function getLinksFromElementModel(elementModell: any): Link | undefined {
  if (elementModell) {
    const link = elementModell.prop(GraphState.PROP_LINK)
    if (link !== undefined) {
      return link
    }
  }
  return undefined
}

function getArtifactTypeFromCellView(cellView: joint.dia.CellView): ArtifactType | undefined {
  const container = (cellView as any).model
  if (container) {
    const artifactContainer = container.prop(GraphState.PROP_ARTIFACT_TYPE)
    if (artifactContainer !== undefined) {
      const traceDataStore = useTraceDataStore()
      return traceDataStore.getArtifactType(artifactContainer)
    }
  }
  return undefined
}

function updatePropertiesWidget(currentArtifact: Artifact): void {
  if (currentArtifact !== undefined) {
    EventBus.emit('updatePropertiesArtifact', currentArtifact)
  }
}

function updatePropertiesWidgetForArtifactType(currentArtifactType: ArtifactType): void {
  if (currentArtifactType !== undefined) {
    EventBus.emit('updatePropertiesArtifactType', currentArtifactType)
  }
}

function getNumberOfLinksForArtifact(artifact: Artifact, links: Link[]): number {
  const linksAsA = links.filter((a) => {
    return a.artifactAId === artifact.id
  }).length

  const linksAsB = links.filter((a) => {
    return a.artifactBId === artifact.id
  }).length
  return linksAsA + linksAsB
}

function addTool(cellView: joint.dia.CellView, newTool: joint.elementTools.Button) {
  //add a specific tool element to the toolsView
  const tools = (cellView as any)._toolsView?.tools ?? ([] as joint.elementTools.Button[])

  tools.push(newTool)

  const toolsView = new joint.dia.ToolsView({
    tools: tools,
  })

  cellView.addTools(toolsView)
}

function removeTool(cellView: joint.dia.CellView, toolName: string) {
  //remove a specific tool element from the toolsView
  const tools = (cellView as any)._toolsView?.tools as joint.elementTools.Button[]

  if (tools) {
    tools.forEach((item, index) => {
      if (item.className === toolName) tools.splice(index, 1)
    })
  }

  const toolsView = new joint.dia.ToolsView({
    tools: tools,
  })

  cellView.addTools(toolsView)
}

export function useHelpers() {
  return {
    getArtifactWithID,
    getArtifactFromElementView,
    getArtifactFromElementModel,
    getLinksFromElementModel,
    getArtifactTypeFromCellView,
    updatePropertiesWidget,
    updatePropertiesWidgetForArtifactType,
    addTool,
    removeTool,
    getNumberOfLinksForArtifact,
  }
}
